import React from 'react';
export function Header() {
  return <header className="w-full bg-[#b9dfea] border-b border-black/15" data-id="element-375" data-mp="1l9wls241gi3n">
      <div className="mx-auto flex h-14 max-w-5xl items-center justify-between px-5 sm:px-8" data-id="element-376" data-mp="2dll0t1gihcn3">
        <a href="#top" className="font-['Prompt'] text-sm font-semibold tracking-tight text-slate-900 transition-opacity hover:opacity-70 sm:text-base" aria-label="HealthDaily homepage" data-id="element-377" data-mp="2il7o63q2099m">
          HealthDaily
        </a>
        <span className="text-sm font-medium text-slate-900 sm:text-base" data-id="element-378" data-mp="2rldwzcat4l2g">Advertorial</span>
      </div>
    </header>;
}